import { checkUserSession } from "../cognito";
import type { ChartImages } from "../../utils/captureCharts";
import { ApiFetcher } from "./ApiFetcher";

export type PreguntaTexts = {
  text: string | null;
  text_resum: string | null;
};

export type TextsData = {
  p1: PreguntaTexts;
  p2: PreguntaTexts;
  p3: PreguntaTexts;
  p4: PreguntaTexts;
  p5: PreguntaTexts;
};

const API_URL = process.env.REACT_APP_BACKEND_API_URL;
const EMPTY_PREGUNTA: PreguntaTexts = { text: null, text_resum: null };

class TextsFetch {
  async getTexts(): Promise<TextsData> {
    const { data } = await new ApiFetcher().callApi<TextsData>({
      endpoint: "texts",
    });
    return data ?? {
      p1: EMPTY_PREGUNTA,
      p2: EMPTY_PREGUNTA,
      p3: EMPTY_PREGUNTA,
      p4: EMPTY_PREGUNTA,
      p5: EMPTY_PREGUNTA,
    };
  }

  async downloadReport(chartImages: ChartImages = {}): Promise<void> {
    const user = await checkUserSession();
    if (!user?.idToken) {
      throw new Error("Sessió no vàlida");
    }

    const response = await fetch(`${API_URL}/texts/report`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.idToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ chart_images: chartImages }),
    });

    if (!response.ok) {
      throw new Error(`Error generant l'informe (${response.status})`);
    }

    const { file_base64, filename } = await response.json();
    const raw = atob(file_base64);
    const bytes = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) {
      bytes[i] = raw.charCodeAt(i);
    }
    const blob = new Blob([bytes], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename ?? "informe_unificat_estudia.docx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}

const textsFetcher = new TextsFetch();

export default textsFetcher;
